import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { PARK_TICKET, PARK_TICKET_SUCCESS, PARK_TICKET_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* parkTicket({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* body: { ticket_id, assignee_id, parking_reason_id, parking_comment } */
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/park`,
      method: 'POST',
      headers: { ...filteredHeaders },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message || 'Ticket parked successfully'}`);
      yield put({
        type: PARK_TICKET_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message || 'Unable to park the ticket'}`);
      yield put({
        type: PARK_TICKET_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    cogoToast.error('Unable to park the ticket');
    yield put({ type: PARK_TICKET_ERROR, payload: error });
  }
}

export function* watchParkTicket() {
  yield takeEvery(PARK_TICKET, parkTicket);
}

function* parkTicketSaga() {
  yield all([fork(watchParkTicket)]);
}

export default parkTicketSaga;
